import React, { useEffect, useState } from 'react'
import Axonslogo from '../../icons/header/axons.svg'
import { CardLogin, CardContainer } from './login.styles'
import { TitlePrimary } from '../../App.styles'
import '../../styleLess/signature/login.scss'
import '../../styleLess/signature/forgot.scss'
import { Button, Form, Input, Row } from 'antd'
import { useHistory } from 'react-router-dom'
import { CheckCircleOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'
import {
  RESET_FORGOT_PASSWORD,
  CHECK_CODE_FORGOT_PASSWORD,
} from 'api/Account/forgotpassword'
import reSend from '../../icons/resend-forgot.svg'

const ResetPasswordComponent = () => {
  // status controller [not-expire,expire,finish,fail]
  const [controller, setController] = useState()
  const history = useHistory()
  const [form1] = Form.useForm()
  const [delay, setDelay] = useState(true)
  const [recaptchakey, setRecaptchaKey] = useState(String)

  const checklinkAuthorization = (path) => {
    const data = {
      code: path,
    }
    try {
      CHECK_CODE_FORGOT_PASSWORD({
        params: data,
      }).then((res) => {
        if (res.status === 200) {
          setController('not-expire')
        } else {
          setController('expire')
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const urlFormMail = window.location.href
    const arrUrl = urlFormMail.split('/')
    const reCaptchaKey = arrUrl[4]
    setRecaptchaKey(reCaptchaKey)
    checklinkAuthorization(reCaptchaKey)
  }, [])

  const onFinish = (value) => {
    const data = {
      code: recaptchakey,
      pwd: value.new_password,
    }
    try {
      RESET_FORGOT_PASSWORD({
        params: data,
      }).then((res) => {
        if (res.status === 200) {
          setController('finish')
          setTimeout(() => {
            setDelay(false)
          }, 100)
        } else {
          setController('fail')
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const validatePassword = (_, value, callback) => {
    const validList = [
      {
        pattern: '.{10,}',
        message: 'Password must be at least 10 characters.',
      },
      {
        pattern: '.*(\\d{1,}).*',
        message: 'Password must have at least 1 digit',
      },
      {
        pattern: '.*([a-z]{1,}).*',
        message: 'Password must have at least 1 lower case character',
      },
      {
        pattern: '.*([A-Z]{1,}).*',
        message: 'Password must have at least 1 upper case character',
      },
      {
        pattern: '(?=.*?[#?!@_$%^&*-])',
        message: 'Password must have at least 1 special character',
      },
    ]

    validList.forEach((regex) => {
      if (value && !value.match(regex.pattern)) {
        callback(regex.message)
      }
    })
    callback()
  }

  const ResetpasswordState = () => {
    return (
      <div className='multi-container-reset-and-forgot wallpaper-reset-container'>
        <h2>Reset your password</h2>
        <p className='tx1 minifont-darkgrey' style={{ textAlign: 'left' }}>
          In order to protect your account, make sure your new password
        </p>

        <Row className='spicifier-row'>
          <div className='dot'></div>{' '}
          <p className='minifont-darkgrey'>Must contain at least 10 characters</p>
        </Row>
        <Row className='spicifier-row'>
          <div className='dot'></div>{' '}
          <p className='minifont-darkgrey'>Must contain at least 1 uppercase letter</p>
        </Row>
        <Row className='spicifier-row'>
          <div className='dot'></div>
          <p className='minifont-darkgrey'>Must contain at least 1 lowercase letter</p>
        </Row>
        <Row className='spicifier-row'>
          <div className='dot'></div>
          <p className='minifont-darkgrey'>Must contain at least 1 special</p>
        </Row>
        <Row className='spicifier-row'>
          <div className='dot'></div>
          <p className='minifont-darkgrey'>character Must contain at least 1</p>
        </Row>
        <Form form={form1} onFinish={onFinish} className='form-pw-reset-container'>
          <h4 className='label' style={{ textAlign: 'left' }}>
            New Password
          </h4>
          <Form.Item
            onChange={(e) =>
              form1.setFieldsValue({
                current_password: e.target.value.replace(/\s/g, ''),
              })
            }
            hasFeedback
            name='new_password'
            rules={[
              {
                required: true,
                message: 'Please enter new password',
                whitespace: true,
              },
              {
                validator: validatePassword,
              },
            ]}
          >
            <Input.Password
              size='large'
              placeholder='New Password'
              iconRender={(visible) =>
                visible ? (
                  <EyeOutlined className='eye-recolor' />
                ) : (
                  <EyeInvisibleOutlined className='eye-recolor' />
                )
              }
            />
          </Form.Item>

          <h4 className='label' style={{ textAlign: 'left' }}>
            Re-enter New Password
          </h4>
          <Form.Item
            name='confirm_new_password'
            dependencies={['new_password']}
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Please confirm your password',
              },
              ({ getFieldValue }) => ({
                validator (_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve()
                  }

                  return Promise.reject(
                    new Error('The two passwords that you entered do not match!'),
                  )
                },
              }),
            ]}
          >
            <Input.Password
              size='large'
              placeholder='New Password'
              iconRender={(visible) =>
                visible ? (
                  <EyeOutlined className='eye-recolor' />
                ) : (
                  <EyeInvisibleOutlined className='eye-recolor' />
                )
              }
            />
          </Form.Item>
        </Form>
        <Button className='BTN_Next' onClick={() => form1.submit()}>
          Reset Password
        </Button>
      </div>
    )
  }
  const OutputStateFinish = () => {
    return (
      <div className='multi-container-reset-and-forgot wallpaper-handle-done'>
        <div className={delay === true ? 'box-icons-before' : 'box-icons'}>
          <CheckCircleOutlined className='checkcircleoutline' />
        </div>
        <h2>Password changed</h2>
        <p className='minifont-darkgrey'>
          You can now use your new password to log in to your account.
        </p>
        <Button
          className='BTN_Next'
          onClick={() => {
            history.push({
              pathname: '/login',
            })
          }}
        >
          Go to Login
        </Button>
      </div>
    )
  }
  const OutputStateExpire = () => {
    return (
      <div className='multi-container-reset-and-forgot wallpaper-handle-expire'>
        <img className='icons-handle' src={reSend} />
        <h2>This link is expired</h2>
        <p className='minifont-darkgrey'>
          The password reset link expires after 1 hour and can only be used once
        </p>
        <Button
          className='BTN_Next'
          onClick={() => {
            history.push({
              pathname: '/login/forgot',
            })
          }}
        >
          Try again
        </Button>
        <h4
          className='text-link'
          onClick={() => {
            history.push({
              pathname: '/login',
            })
          }}
        >
          Return to Login
        </h4>
      </div>
    )
  }
  return (
    <CardLogin>
      <CardContainer>
        <img
          className='nav-logo'
          src={Axonslogo}
          style={{ width: '128px', height: '128px', marginBottom: ' 16px' }}
        />
        <TitlePrimary className='reponse-iproject-title'>{'AXONS PROJECT'}</TitlePrimary>
        {controller === 'not-expire'
          ? ResetpasswordState()
          : controller === 'expire'
          ? OutputStateExpire()
          : OutputStateFinish()}
      </CardContainer>
    </CardLogin>
  )
}

export default ResetPasswordComponent
